// extracted by mini-css-extract-plugin
module.exports = {"notification-mob-wrapper":"Notification_notification-mob-wrapper__1Z_4h","notification-desktop-wrapper":"Notification_notification-desktop-wrapper__1dMZk"};